











































import {Component} from "vue-property-decorator"
import BaseVue from "../utils/BaseVue"
import {StoreRef} from "@/services/models.types"
import logger from "@/utils/logging"

interface StoreInfo extends StoreRef {
    retailGroup: string
}

@Component
export default class StoreSelector extends BaseVue {

    private get isDataLoading(): boolean {
        return this.$typedStore.state.account.isLoading
    }

    get items(): StoreRef[] {
        if (this.$typedStore.state.account.data === undefined) {
            return []
        }

        return this.$typedStore.state.account.data.stores
            .map((item) => {
                const cleanedName = item.name.replace(RegExp(`^${item.retailGroupId} `, "i"), "")
                const capitalizedName = cleanedName.charAt(0).toUpperCase() + cleanedName.slice(1)
                return {...item, name: capitalizedName}
            })
    }

    private created() {
        if (this.$typedStore.state.account.data === undefined) {
            this.$typedStore.actions.account.loadUserAccount()
        }
    }
}
